import { Inject } from '@angular/core';

export class Util {

    private static getPrototypeOf = Object.getPrototypeOf;
    static url: any;
 constructor() {
     Util.url=window.location.href;
 }


    public static isDefined(value: any): boolean {
        return typeof value !== 'undefined';
    }

    public static isDefinedAndNotNull(value: string | any[] | null | undefined): boolean {
        return (typeof value !== 'undefined' && value !== null && value !==  '' && value !== undefined );
    }

    public static isUndefined(value: any): boolean {
        return typeof value === 'undefined';
    }

    public static isUndefinedOrNull(value: null): boolean {
        return (typeof value === 'undefined' || value == null);
    }

  public static isEmptyRoute(value: string): boolean {
    return (value === '/' || value === './');
  }

    public static isObject(value: null): boolean {
        return value !== null && typeof value === 'object';
    }

    public static isBlankObject(value: null): boolean {
        return value !== null && typeof value === 'object' && !this.getPrototypeOf(value);
    }

    public static isString(value: string): boolean {
        return typeof value === 'string';
    }

    public static isNumber(value: any): boolean {
        return typeof value === 'number';
    }

    public static isDate(value: any): boolean {
        return toString.call(value) === '[object Date]';
    }

    public static isFunction(value: any) {
        return typeof value === 'function';
    }

    public static isBoolean(value: any): boolean {
        return typeof value === 'boolean';
    }

    public static includes(array: any, obj: any) {
        return Array.prototype.indexOf.call(array, obj) !== -1;
    }

    public static trim(value: string) {
        return this.isString(value) ? value.trim() : value;
    }

    public static isEmptyString(value: string): boolean {
        let result: boolean = true;
        if (this.isDefinedAndNotNull(value)) {
            value = value.trim();
            result = (value.length === 0);
        }
        return result;
    }
    public static isEmptyArray(value: any[]): boolean {
        let result: boolean = true;
        if (this.isDefinedAndNotNull(value)) {
            result = (value.length === 0);
        }
        return result;
    }

    public static copyObject(obj: any): any {
        return Object.assign({}, obj);
    }

    public static copyArray(obj: any[]) {
        return Object.assign([], obj);
    }

    public static ignoreJsonNullValue(data: any): any {
        const replacer = function (key: any, value: null | undefined) {
            if (value == null || value === undefined) {
                return undefined;
            }
            return value;
        };
        const jsonData = JSON.parse(JSON.stringify(data, replacer));
        return jsonData;
    }

    public static removeSpecialCharacter(value: string): string {
        value = value.trim();
        return value.replace(/[^a-zA-Z]/g, '');
    }

    public static getQueryParamByKey(key: string): any {
        const url:any = this.url;
        key = key.replace(/[\[\]]/g, '\\$&');
        const regex = new RegExp('[?&]' + key + '(=([^&#]*)|&|#|$)'),
            results = regex.exec(url);
        if (!results) { return null; };
        if (!results[2]) { return ''; };
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }

    public static replace(value: string, replaceString: string, replaceWith: any): string {
        return value.replace(replaceString, replaceWith);
    }

    public static replaceAll(value: string, replaceString: string, replaceWith: any): string {
        return value.replace(new RegExp(replaceString, 'g'), replaceWith);
    }

    public static splitIntoSubArray(data: Array<any>, start: number, end: number): Array<any> {
        let dataSet = [];
        if (Util.isDefinedAndNotNull(data)) {
            dataSet = data.slice(start, end);
        }
        return dataSet;
    }

    
  
}
